// extracted by mini-css-extract-plugin
export default {"button":"edit-button_button__Jw1yA"};